import React, { Component } from 'react';

import './Helper.css';



class Helper extends Component {


    constructor(props) {

        super(props);       
        
    }

    render() {

        const {s , helper} = this.props;

        let contenu = [];

        // default values 
        let cl = 'Helper';
        let helper_gif  = 'tap'

        let trs = 'rotate('+s.rot+')';

        let replaceX = '0%';   // hack pour replacer le helper 256x256 du swipe dans la zone plus large de 512x256 (34x24%)

        if(helper.indexOf('swipe_') >= 0)
        {   
            helper_gif = 'swipe'; // le même gif pour left/right/up/down
            cl+= ' swipe_tap';

            replaceX ='10%';    // hack voir plus haut
        }else if(helper == 'mask-c07')
        {
            helper_gif = 'path-c07';
            cl+= ' C07';
        }else if(helper == 'mask-c11')
        {
            helper_gif = 'path-c11';
            cl+= ' C11';
        }else if(helper == 'swirle-18')
        {
            helper_gif = 'rotate';
            cl+= ' C18';
            trs = 'scaleX(-1)' // remplace par un flip sur X 
        }else if(helper.indexOf('drag_video') >= 0)
        {
            helper_gif = 'drag-video'; // le même gif pour left/right/up/down
            cl+= ' drag-video';        
            replaceX ='30%';
        }else if(helper == 'pendule-15a')
        {
            helper_gif = 'rotate';
            trs = 'scaleX(-1)' // remplace par un flip sur X 
            cl+=' pendule1';
        }else if(helper == 'pendule-15b')
        {
            helper_gif = 'rotate';            
            trs = 'scaleX(-1)' // remplace par un flip sur X 
            cl+=' pendule2';
        }else /* le reste : tap, etc.*/
        {
            cl+= ' swipe_tap';            
        }
    
        /* rendu */

        let str_left = 'calc('+s.left+' + '+replaceX+')';
        //console.log(str_left, trs);

        const style = { 
            backgroundImage : `url(./UI/helper-${helper_gif}.gif)`,
            top:  s.top, // non utilisé si x n'est pas renseigné, centrera automatiquement le helper
            left: str_left,
            transform: trs }

        contenu.push( <div className={ cl } key='helper1' style={ style }>
                </div>);

        return( contenu );
    } 
  
}

//----------------------------------------------------------------------------

export default Helper;



// WEBPACK FOOTER //
// ./src/Helper.js